import React from 'react';
import { Grid, Box } from '@mui/material';
import TeamSubteamMembersSidenav from 'team/components/subteams/TeamSubteamMembersSidenav';

const TeamSubteamMembersLayout = ({ 
    onMenuItemClick, 
    selectedItem,
    mainContent 
}) => {
    return (
        <Grid container sx={{ height: '100vh', paddingTop: 2, paddingBottom: 4, paddingLeft: 4, paddingRight: 4, overflow: 'hidden' }}>
            <Grid
                item
                xs={12}
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                }}
            >
                {/* Sidebar */}
                <Grid
                    item
                    xs={12}
                    sm={2.5}
                    md={2}
                    sx={{
                        borderRight: '1px solid #e0e0e0',
                        backgroundColor: '#ffffff',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 4,
                        paddingBottom: 4,
                        paddingLeft: 1.5,
                        paddingRight: 1.5,
                        borderRadius: '8px 0 0 8px',
                        overflow: 'hidden',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}
                >
                    <TeamSubteamMembersSidenav
                        onMenuItemClick={onMenuItemClick}
                        selectedItem={selectedItem}
                    />
                </Grid>

                {/* Main content area */}
                <Grid
                    item
                    xs={12}
                    sm={9.5}
                    md={10}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 4,
                        backgroundColor: '#ffffff',
                        borderRadius: '0 8px 8px 0',
                        height: 'calc(100vh - 16px - 32px)',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '6px',
                        },
                        scrollbarWidth: 'thin',
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        {mainContent}
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TeamSubteamMembersLayout;

